module.exports = __webpack_public_path__ + "img/front_rise.a9c9b081.png";